import { ReloadOutlined, UploadOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { Alert, Button, Tooltip } from 'antd';
import { useState } from 'react';
import { getHarnessOrganization } from '@/apps/harness/services/harness';
import { useAppContext } from '@/common/hooks/AppStateProvider';
import { useOrganizationPath } from '@/common/hooks/use-organization-path';
import HarnessInstancesTable from './HarnessInstancesTable';
import HarnessVersionModal from './HarnessVersionModal';

const HarnessOrganization = () => {
  const { organizationId } = useOrganizationPath();
  const { session } = useAppContext();
  const [versionAction, setVersionAction] = useState(null);
  const organization = useQuery({
    queryKey: ['harness', organizationId, session.user.id, 'organization'],
    queryFn: () => getHarnessOrganization({ organizationId }),
    retry: false,
    refetchOnWindowFocus: false,
    refetchInterval: (query) =>
      versionAction?.open &&
      !query.state.error &&
      ['pending', 'pulling', 'running'].includes(query.state.data?.upgrade?.status)
        ? 3000
        : false,
  });
  const { data } = organization;
  const busy = ['pending', 'pulling', 'running'].includes(data?.upgrade?.status);
  const unavailable =
    organization.isPending || organization.isFetching || organization.isError || busy;
  let emptyText = '暂无符合条件的成员';
  if (!data) {
    emptyText = organization.isPending ? '正在加载成员' : '成员列表加载失败';
  }
  const feedback = organization.isError ? (
    <Alert
      type="warning"
      showIcon
      title="状态暂时无法确认"
      description={
        data ? '请刷新重试，当前显示的是最近一次查询结果。' : '尚未获取到组织状态，请刷新重试。'
      }
    />
  ) : null;
  return (
    <>
      <HarnessInstancesTable
        instances={data?.instances || []}
        loading={organization.isPending}
        emptyText={emptyText}
        feedback={feedback}
        toolbar={[
          <Button
            key="update"
            aria-label="更新版本"
            type="primary"
            icon={<UploadOutlined />}
            disabled={organization.isPending}
            onClick={() => {
              setVersionAction({ open: true });
              organization.refetch();
            }}
          >
            更新版本
          </Button>,
          <Tooltip key="refresh" title="刷新状态">
            <Button
              aria-label="刷新状态"
              type="text"
              icon={<ReloadOutlined />}
              disabled={organization.isFetching}
              onClick={() => organization.refetch()}
            />
          </Tooltip>,
        ]}
      />
      {versionAction && (
        <HarnessVersionModal
          organization={data}
          open={versionAction.open}
          unavailable={unavailable}
          statusError={organization.isError}
          onRefreshStatus={() => organization.refetch()}
          onClose={() => setVersionAction((action) => ({ ...action, open: false }))}
          onClosed={() => setVersionAction(null)}
        />
      )}
    </>
  );
};
export default HarnessOrganization;
